import { CarlineBase, CarlinesWithSalesgroups, OneFormState } from 'src/types';
import { findCarlineFromSalesgroup } from '.';
import { useFaContent } from 'src/feature-app';


export const findCarline = (
  carlines: CarlineBase[] | CarlinesWithSalesgroups[],
  code: number | string,
  salesgroupId?: number
) => {
  if (salesgroupId) {
    const carline = findCarlineFromSalesgroup(carlines, salesgroupId);
    return carline;
    } else if (carlines.find((carline: CarlineBase) => carline.code === Number(code))) {
    const carline = carlines.find((carline: CarlineBase) => carline.code === Number(code));
    return carline;
  } else {
    const carline = carlines.find((carline: CarlineBase) => carline.name === (code));
    return carline;
  }
 
  return null;
};
